import React from 'react';
import PropTypes from 'prop-types';

import BoardsProvider from '/imports/job-tracking/api/context/boards.context';
import CancelSubscriptionForm from '/imports/core/ui/components/CancelSubscriptionForm';
import GeneralProvider from '/imports/job-tracking/api/context/general.context';
import HeaderSkeleton from '/imports/dashboard/ui/skeleton/HeaderSkeleton';
import { isJobTrackEnable } from '/lib/helpers';
import Head from 'next/head';
import SearchProvider from '/imports/job-tracking/api/context/search.context';
import useMountedState from '/imports/core/api/useMountedState';
import useIntl from '/imports/core/api/useIntl';
import { replaceString } from '/imports/core/ui/helpers';
import useDomain from '/imports/core/hooks/useDomain';
import withAccountInfo from '/imports/core/api/accounts/withAccountInfo';
import CancelSubscriptionLayout from 'imports/core/ui/layout/CancelSubscriptionLayout';

const CancelSubscription = () => {
  const { renderIfMounted } = useMountedState();
  const { t, locale } = useIntl();
  const { getBrandName } = useDomain();
  const metaTitle = replaceString(t('meta_title_builder'), { '{BRAND}': getBrandName() });
  const metaDesc = replaceString(t('meta_description_builder'), { '{BRAND}': getBrandName() });
  const renderCancelSubLayout = () => {
    if (isJobTrackEnable()) {
      return (
        <GeneralProvider>
          <BoardsProvider boards={[]}>
            <SearchProvider>
              <CancelSubscriptionLayout>
                <CancelSubscriptionForm />
              </CancelSubscriptionLayout>
            </SearchProvider>
          </BoardsProvider>
        </GeneralProvider>
      );
    } else {
      return (
        <CancelSubscriptionLayout>
          <CancelSubscriptionForm />
        </CancelSubscriptionLayout>
      );
    }
  };
  return renderIfMounted(
    <React.Fragment>
      <Head>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
      </Head>
      {renderCancelSubLayout()}
    </React.Fragment>,
  );
};

CancelSubscription.propTypes = {
  pageProps: PropTypes.shape({
    boards: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  }),
};

export default withAccountInfo(CancelSubscription, HeaderSkeleton);
